import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, CardContent, Card, Grid, Button } from '@material-ui/core';
import { faCheckCircle, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useWindowSize } from '../../customHooks/useWindowSize';
import funcTranslateHelper from '../../i18next/funcTranslateHelper';
import { connect } from 'react-redux';
import CertificateGenerator from '../CertificateGenerator';
import { URL_TRAZER } from '../../constants/api_urls';
import { Link } from 'react-router-dom';

export const useStyles = makeStyles(theme => ({
  card: {
    width: '100%',
    background: '#FFFFFF',
    boxShadow: '0 5px 28px -6px rgba(60,51,79,0.22)'
  },
  generalText: {
    fontFamily: 'Roboto-Light',
    fontSize: 16,
    color: '#6F6F6F'
  },
  mainTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
    color: '#6F6F6F',
    letterSpacing: 0.4,
    textAlign: 'left',
    marginBottom: 4,
    marginTop: 10
  },
  secondaryTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
    color: '#6F6F6F',
    letterSpacing: 0.4,
    textAlign: 'left',
    marginBottom: 4,
    marginTop: 4
  },
  hashCode: {
    fontFamily: 'Roboto-Regular',
    fontSize: 16,
    color: '#000000',
    letterSpacing: 0
  }
}));

const SuccessContractResult = props => {
  const { data: { data }, itemKey, date, itemType } = props;

  const size = useWindowSize();
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent style={{ padding: 0, display: 'flex' }}>
        <Grid
          container
          wrap='nowrap'
          direction={size.width > 375 ? 'row' : 'column'}
        >
          <Grid
            container
            item
            xs={size.width > 600 ? 3 : size.width <= 375 ? 12 : 3}
            direction='row'
            alignItems='flex-start'
            spacing={0}
            style={{
              width: '100%',
              height: '100%',
              marginBottom: size.width > 375 ? 0 : 25,
              marginLeft: size.width < 600 && size.width > 375 ? 10 : 0,
              marginRight: size.width < 600 && size.width > 375 ? 10 : 0
            }}
          >
            <Grid
              container
              item
              xs={12}
              justify='center'
              direction='row'
              style={{
                marginLeft: size.width <= 375 ? 20 : 0,
                marginRight: size.width <= 375 ? 20 : 0
              }}
            >
              <Grid
                item
                xs={2}
              >
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  style={{
                    color: '#42BE65',
                    width: size.width > 600 ? 125.1 : 53.1,
                    height: size.width > 600 ? 125.1 : 53.1,
                    marginTop:
                    size.width > 600 ? 50 : size.width <= 375 ? 12 : 37.1
                  }}
                />
                <Typography
                  style={{
                    fontFamily: 'Roboto-Light',
                    fontSize: 14,
                    color: '#AAAAAA',
                    letterSpacing: 0,
                    marginTop: 14.9
                  }}
                >
                  {funcTranslateHelper('Trazer.Success.certified')}
                </Typography>
              </Grid>

            </Grid>

          </Grid>
          <Grid
            container justify='center'
            alignItems='center'
          >

            <Grid
              item
              xs={10}
            >
              <Typography
                className={classes.generalText}
                style={{ marginTop: 26 }}
              >
                {funcTranslateHelper('Trazer.Success.certificationEntity')}
              </Typography>
              <Typography className={classes.mainTitle}>
                <b>{funcTranslateHelper(`Trazer.Success.itemType.${itemType}`)}</b>
              </Typography>
              <Typography
                style={{
                  overflowWrap: 'break-word'
                }}
                className={classes.hashCode}
                display='inline'
              >
                {data[0].contractId}{' '}
              </Typography>

              {size.width > 740 && <br />}{' '}

              {data.map(
                (dataItem, i) =>

                  // filtro para solo pintar los assets en los stage que correspondan
                  <Grid
                    key={i}
                    container
                    item
                    style={{
                      textAlign: 'left'
                    }}
                  >

                    <Grid
                      item
                      xs
                    >

                      {!dataItem.currentSignatory &&
                        <div>
                          <Typography
                            className={classes.generalText}
                            style={{ marginTop: 19 }}
                          >
                            {funcTranslateHelper('Trazer.Success.contract.include')}
                          </Typography>
                          <Typography
                            className={classes.generalText}
                            style={{
                              overflowWrap: 'break-word'
                            }}
                          >
                            {dataItem.hash}
                          </Typography>
                          <Typography
                            className={classes.generalText}
                            style={{ marginTop: 19 }}
                          >
                            {funcTranslateHelper('Trazer.Success.contract.create')}
                          </Typography>
                        </div>}
                      {dataItem.currentSignatory &&
                        <div>
                          <hr
                            style={{
                              color: 'black',
                              backgroundColor: 'black',
                              height: 1
                            }}
                          />
                          <Typography
                            className={classes.mainTitle}
                          >
                            <b>{funcTranslateHelper('Trazer.Success.contract.identity')}</b>
                          </Typography>
                          <Typography
                            className={classes.generalText}
                            style={{
                              overflowWrap: 'break-word'
                            }}
                          >
                            <Link
                              onClick={() => { window.open(URL_TRAZER + 'identity/' + dataItem.currentSignatory.hash); }}
                            >{dataItem.currentSignatory.hash}
                            </Link>
                          </Typography>
                        </div>}
                      <Typography className={classes.mainTitle}>
                        <b>{funcTranslateHelper('Trazer.Success.privateTransaction.title')}</b>
                      </Typography>
                      <Typography
                        className={classes.generalText}
                        style={{
                          overflowWrap: 'break-word'
                        }}
                      >
                        {dataItem.tx_hash}
                      </Typography>
                      <Typography
                        className={classes.secondaryTitle}
                        display={size.width > 740 ? 'inline' : 'block'}
                      >
                        <b>{funcTranslateHelper('Trazer.Success.privateTransaction.timestamp')}</b>
                      </Typography>
                      <Typography
                        className={classes.generalText}
                        display={size.width > 740 ? 'inline' : 'block'}
                      >
                        {dataItem.tx_timeStamp}
                      </Typography>
                      <Typography className={classes.mainTitle}>
                        <b>{funcTranslateHelper('Trazer.Success.publicTransaction.title')}</b>
                      </Typography>
                      <Typography
                        className={classes.generalText}
                        style={{ overflowWrap: 'break-word' }}
                      >
                        {dataItem.public_tx_hash}
                      </Typography>
                      <Typography
                        className={classes.secondaryTitle}
                        display={size.width > 740 ? 'inline' : 'block'}
                      >
                        <b>{funcTranslateHelper('Trazer.Success.publicTransaction.timestamp')}</b>
                      </Typography>
                      <Typography
                        className={classes.generalText}
                        display={size.width > 740 ? 'inline' : 'block'}
                      >
                        {dataItem.public_tx_timeStamp}
                      </Typography>
                      {size.width > 740 && <br />}{' '}
                      <Typography
                        className={classes.secondaryTitle}
                        display={size.width > 740 ? 'inline' : 'block'}
                      >
                        <b>{funcTranslateHelper('Trazer.Success.publicTransaction.block')}</b>
                      </Typography>
                      <Typography
                        className={classes.generalText}
                        display={size.width > 740 ? 'inline' : 'block'}
                      >
                        {dataItem.public_tx_block}
                      </Typography>
                      {size.width > 740 && <br />}{' '}
                      <Typography
                        className={classes.secondaryTitle}
                        display={size.width > 740 ? 'inline' : 'block'}
                      >
                        <b>{funcTranslateHelper('Trazer.Success.publicTransaction.confirmations')}</b>
                      </Typography>
                      <Typography
                        className={classes.generalText}
                        display={size.width > 740 ? 'inline' : 'block'}
                      >
                        {dataItem.public_tx_validations}
                      </Typography>
                      {size.width > 740 && <br />}

                      {dataItem.extraInfoSignature && dataItem.extraInfoSignature.tsa && (
                        <Grid
                          item
                          xs
                        >
                          {size.width > 835 && <br />}
                          <Typography className={classes.mainTitle}>
                            <b>{funcTranslateHelper('Trazer.Success.tsa.title')}</b>
                          </Typography>
                          <Typography
                            className={classes.secondaryTitle}
                            display={size.width > 740 ? 'inline' : 'block'}
                          >
                            <b>{funcTranslateHelper('Trazer.Success.tsa.time')}</b>
                          </Typography>
                          <Typography
                            className={classes.generalText}
                            display={size.width > 740 ? 'inline' : 'block'}
                          >
                            {dataItem.extraInfoSignature.tsa.time}
                          </Typography>
                          <Grid xs>
                            <Button
                              style={{
                                fontFamily: 'Helvetica',
                                fontSize: 14,
                                color: '#0F62FE',
                                letterSpacing: 0.16,
                                lineHeight: '18 px',
                                border: '1px solid #0F62FE',
                                borderRadius: 0,
                                marginTop: 32,
                                marginBottom: 35,
                                textTransform: 'none'
                              }} onClick={() => downloadBase64File(dataItem.extraInfoSignature.tsa.tsr, dataItem.extraInfoSignature.publicIdentity + '.tsr')}
                            >
                              {funcTranslateHelper('Trazer.Success.tsa.button')}
                              <FontAwesomeIcon
                                icon={faClock}
                                style={{
                                  color: '#0F62FE',
                                  width: 14,
                                  height: 14,
                                  marginLeft: 22.5,
                                  marginRight: 14
                                }}
                              />
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>

                    {!dataItem.currentSignatory &&
                      <Typography
                        className={classes.generalText}
                        style={{ marginTop: 19 }}
                      >
                        {funcTranslateHelper('Trazer.Success.wasSigned')}
                      </Typography>}
                  </Grid>
              )}
              <Grid xs>
                <Typography
                  className={classes.generalText}
                  style={{
                    marginTop: 29,
                    marginBottom: size.width > 600 ? 23 : 0
                  }}
                >
                  {funcTranslateHelper('Trazer.Success.certificateEffect')}
                  {date} UTC
                </Typography>
                <CertificateGenerator chaincode={itemType} hash={itemType === 'contract' ? data[data.length - 1].contractId : itemKey} data={data[data.length - 1]} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
const downloadBase64File = (base64Data, fileName) => {
  const linkSource = `data:application/timestamp-reply;base64,${base64Data}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

const mapStateToProps = state => ({
  configFile: state.configFile
});

export default connect(mapStateToProps, null)(SuccessContractResult);
